import { MessageCentreStoreActionsType } from '../../Types/MessageCentreReducerTypes';
import { MessageCentreStoreStateType } from '../../Types/MessageCentreStoreTypes';

export default function MessageCentreReducer(
	state: MessageCentreStoreStateType,
	action: MessageCentreStoreActionsType,
): MessageCentreStoreStateType {
	switch (action.type) {
		case 'updateThreadStatus':
			return {
				...state,
				messageUpdateStatus: { ...state.messageUpdateStatus, updating: action.state },
			};
		case 'updateThreadStatusMessageId':
			return {
				...state,
				messageUpdateStatus: { ...state.messageUpdateStatus, messageId: action.messageId },
			};
		case 'toggleThreadSearchModal':
			return {
				...state,
				showFilterModal: action.state,
			};
		case 'toggleThreadOpen':
			return {
				...state,
				messageThreadOpen: action.state,
			};
		case 'updateCurrentThreadId':
			return {
				...state,
				currentThreadId: action.threadId,
			};
		default:
			return state;
	}
}
